if (!customElements.get('logo-carousel')) {
  customElements.define(
    'logo-carousel',
    class LogoCarousel extends HTMLElement {
      constructor() {
        super();
        this.track = null;
        this.wrapper = null;
        this.cloned = false;
      }

      connectedCallback() {
        this.track = this.querySelector('[data-logo-carousel]');
        if (!this.track) return;

        this.wrapper = this.track.parentElement;
        this.initAnimation();
      }

      disconnectedCallback() {
        // Cleanup if needed
      }

      initAnimation() {
        const images = this.track.querySelectorAll('img');
        let loadedCount = 0;
        const totalImages = images.length;

        const checkLoaded = () => {
          loadedCount++;
          if (loadedCount === totalImages || totalImages === 0) {
            setTimeout(() => this.setupLoop(), 100);
          }
        };

        if (totalImages > 0) {
          for (const img of images) {
            if (img.complete) {
              checkLoaded();
            } else {
              img.addEventListener('load', checkLoaded);
              img.addEventListener('error', checkLoaded);
            }
          }
        } else {
          setTimeout(() => this.setupLoop(), 100);
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setupLoop());
        }

        window.addEventListener('resize', () => this.setupLoop());
      }

      setupLoop() {
        if (!this.track || !this.wrapper) return;

        // Clone items once for seamless looping
        if (!this.cloned) {
          const items = [...this.track.children];
          for (const item of items) {
            const clone = item.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            this.track.appendChild(clone);
          }
          this.cloned = true;
        }

        // Measure original half (before clones)
        const totalItems = this.track.children.length;
        const originalCount = totalItems / 2;
        let originalWidth = 0;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 40;

        for (let i = 0; i < originalCount; i++) {
          originalWidth += this.track.children[i].offsetWidth;
        }
        originalWidth += gap * originalCount;

        this.track.style.setProperty('--scroll-distance', `-${originalWidth}px`);
      }
    }
  );
}